module.exports = __webpack_public_path__ + "components/home-header/static/header-3--huge-752292041023d854a68dbf631e32b8f5.jpg";